import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { MenuProvider } from './parts/menu-context.js';
import styles from './index.p.module.css.js';
import { useMenuKeyboardNavigation } from './parts/use-menu-keyboard-navigation.js';

const Menu = _ref => {
  let {
    tag = 'ul',
    itemTag,
    iconPlacement,
    disabled,
    size = 'm',
    mode,
    disableCursor = false,
    theme,
    enableKeyboardNavigation = false,
    activateFirstItem = false,
    className,
    wrapItemsWithLi,
    returnFocusOnUnmount = false,
    ...restProps
  } = _ref;
  const Tag = tag;
  const {
    activeItemRef,
    registerItem,
    unregisterItem,
    isKeyboardNavigating
  } = useMenuKeyboardNavigation({
    enableKeyboardNavigation,
    activateFirstItem,
    returnFocusOnUnmount
  });
  return /*#__PURE__*/React.createElement(MenuProvider, {
    itemTag: itemTag,
    iconPlacement: iconPlacement,
    disabled: disabled,
    size: size,
    disableCursor: disableCursor || isKeyboardNavigating,
    mode: mode,
    theme: theme,
    registerItem: registerItem,
    unregisterItem: unregisterItem,
    activeItemRef: activeItemRef.current,
    isKeyboardNavigating: isKeyboardNavigating,
    wrapWithLi: wrapItemsWithLi ?? tag === 'ul'
  }, /*#__PURE__*/React.createElement(Tag, {
    className: cn(!enableKeyboardNavigation && styles.keyboardNavigationDisabled, className),
    ...restProps
  }));
};

Menu.propTypes = {
  size: PropTypes.oneOf(['l', 'm', 's']),
  mode: PropTypes.oneOf(['clear', 'classic', 'rock']),
  theme: PropTypes.oneOf(['light', 'dark']),
  disableCursor: PropTypes.bool,
  disabled: PropTypes.bool,
  iconPlacement: PropTypes.oneOf(['left', 'right']),
  itemTag: PropTypes.elementType,
  tag: PropTypes.elementType
};
export { Menu, Menu as default };
